export const SERVICE_FEE_FACTOR = 0.015;

export default {
  methods: {
    getServiceFee(value) {
      return Math.round((value * SERVICE_FEE_FACTOR + 1) * 100) / 100;
    },
  },
}
